import { render } from "./BlockGalleryBlockPreview.vue?vue&type=template&id=4387081c&scoped=true"
import script from "./BlockGalleryBlockPreview.vue?vue&type=script&lang=js"
export * from "./BlockGalleryBlockPreview.vue?vue&type=script&lang=js"

import "./BlockGalleryBlockPreview.vue?vue&type=style&index=0&id=4387081c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4387081c"]])

export default __exports__